<template>
    <div id="app-footer">
        <div class="footer-socials-wrap">
            <div class="footer-socials">
                <div class="footer-socials-social" onclick="window.open('https://www.facebook.com/vinleit.is')">
                    <img class="social-fb" src="../assets/social_fb_white.png" alt="">
                </div>
                <div class="footer-socials-social" onclick="window.open('https://www.instagram.com/vinleit.is/')">
                    <img class="social-in" src="../assets/social_in_white.png" alt="">
                </div>
            </div>
        </div>
        <div class="footer-nav-wrap">
            <router-link to="/">
                <div class="footer-nav-item">
                    <p>Heim</p>
                </div>
            </router-link>
            <router-link to="/vin">
                <div class="footer-nav-item">
                    <p>Öll vín</p>
                </div>
            </router-link>
            <router-link to="/blog">
                <div class="footer-nav-item">
                    <p>Greinar</p>
                </div>
            </router-link>
            <router-link to="/vin-med-mat">
                <div class="footer-nav-item">
                    <p>Vín með mat</p>
                </div>
            </router-link>
            <router-link to="/hafa-samband">
                <div class="footer-nav-item">
                    <p>Hafa samband</p>
                </div>
            </router-link>
            <div class="footer-nav-item">
                <a href="https://atelierduvin.is/"><p>Verslun</p></a>
            </div>
            <div class="web-developer" onclick="window.open('http://www.hinriks.com/')">
                <p>Hannað af HinrikS</p>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {

}
</script>

<style>
@media only screen and (max-width: 768px) {
    #app-footer {
        height:450px;
        padding-bottom: 20px;
    }
    .footer-nav-wrap {
        width:100%;
        height:100px;
        margin:auto;
    }
    .footer-nav-item p {
        font-size: 22px;
    }
    .web-developer {
        margin-top: 20px;
    }
}
@media only screen and (min-width: 769px) {
    #app-footer {
        height:200px;
    }
    .footer-nav-wrap {
        display:flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width:500px;
        height:100px;
        margin:auto;
    }
    .footer-nav-item {
        display:inline-block;
        padding:5px;
    }
    .footer-nav-item p {
        font-size: 22px;
    }
}
@media only screen and (min-width: 1200px) {
    
}
#app-footer {
    clear:both;
    margin-top: 50px;
    width:100%;
    background-color: white;
    box-shadow: 0 1px 4px #a8a5a3;
}
.footer-socials-wrap {
    padding-top: 40px;
}
.footer-socials {
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width:120px;
    height:50px;
    margin:auto;
}
.footer-socials-social {
    height: 50px;
    width: 50px;
    line-height: 50px;
    border-radius: 100%;
    background-color: #b33b3b;
    display:inline-block;
    cursor: pointer;
}
.footer-socials-social img {
    max-height: 60%;
}
.social-fb {
    vertical-align: -8px; 
}
.social-in {
    vertical-align: -8px; 
}
.footer-nav-item {
    cursor: pointer;
}
.footer-nav-item p {
    color: #b33b3b;
    margin-bottom: 0px;
}
.web-developer {
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #969696;
    font-size: 15px;
}
.web-developer p {
    margin: 0;
}
</style>